export const getCommunicationsForStudents = () => {
  return `
query CommunicationsSearch($studentIds: [String!]!, $guardianId: String!, $year: Int!, $startDate: String!, $limit: Int!, $offset: Int!) {
  communicationsSearch(
    criteria: {studentIds: $studentIds, guardianId: $guardianId, year: $year, startDate: $startDate},
    sortField: "scheduleDate"
    sortDirection: "DESC"
    limit: $limit
    offset: $offset
  ) {
    content {
      id
      title
      email
      sms
      createdBy
      dateCreated
      studentId
      emails {
        subject
      }
      smses {
        message
      }
      readStatus {
        id
      }
    }
    pageInfo {
      currentPage
      hasNext
      hasPrevious
      pageSize
      totalElements
      totalPages
    }
  }
}
`;
};

/**
 * Fetches the total number of unread messages for a guardian across one or more students
 * from the given start date onward.
 */
export const getUnreadMessageCount = () => `
query UnreadMessageCount($guardianId: String!, $studentIds: [String!]!, $startDate: String!) {
  unreadMessageCount(
    input: {
      guardianId: $guardianId
      studentIds: $studentIds
      startDate: $startDate
    }
  )
}
`;

/**
 * Fetches a single communication by ID with full email body and attachment metadata.
 * Use this to lazy-load the email body when a user opens an announcement.
 */
export const getCommunicationById = () => `
query Communication($id: ID!) {
  communication(id: $id) {
    id
    school
    schoolCode
    year
    studentId
    studentIds
    emails {
      id
      subject
      html
    }
    attachments {
      file {
        id
        name
        sharePointName
        extension
        fileSize
      }
    }
    readStatus {
      id
      communicationId
      guardianSynergyId
      dateCreated
    }
  }
}
`;
